export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  retrospectiveDay: state => state.retrospectiveDay,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  workOrderQueue: state => state.workOrderQueue,
  techQueue: state => state.techQueue,
  toolQueue: state => state.toolQueue,
  dispatchLog: state => state.dispatchLog,
  queue: state => state.queue,
  workOrderQueueFiltered: state => state.workOrderQueueFiltered,
  techQueueFiltered: state => state.techQueueFiltered,
  toolQueueFiltered: state => state.toolQueueFiltered,
  breakdownSummary: state => state.breakdownSummary
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/getters.js